import tooltipConfig from "app/pages/website-analysis/demographics/GenderDistributionPieChart/tooltipConfig";
import combineConfigs from "pro-features/components/Chart/src/combineConfigs";
import { percentageFilterWithoutNA } from "app/filters/ngFilters";
import legendConfig from "app/pages/website-analysis/traffic-sources/search/tabs/SearchOverviewTraffic/legendConfig";

export const getPieChartConfig = ({ type, filter }) => {
    const yAxisFormatter = ({ value }) => percentageFilterWithoutNA()(value, 2);
    return combineConfigs({ type, filter, yAxisFormatter }, [
        legendConfig({ yAxisFormatter }),
        tooltipConfig({ yAxisFormatter }),
        {
            chart: {
                animation: false,
                type,
                plotBackgroundColor: "transparent",
                height: 160,
            },
            plotOptions: {
                pie: {
                    innerSize: "58%",
                    animation: false,
                    showInLegend: true,
                    cursor: "pointer",
                    center: ["50%", "45%"],
                    borderWidth: 0,
                    dataLabels: {
                        enabled: false,
                    },
                },
            },
        },
    ]);
};

export const getPieChartStyle = () => {
    return {
        style: {
            height: "150px",
            flexGrow: 1,
            display: "flex",
        },
    };
};
